import { render, staticRenderFns } from "./CarouselImageEdit.vue?vue&type=template&id=31849f0c&scoped=true&"
import script from "./CarouselImageEdit.vue?vue&type=script&lang=js&"
export * from "./CarouselImageEdit.vue?vue&type=script&lang=js&"
import style0 from "./CarouselImageEdit.vue?vue&type=style&index=0&id=31849f0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31849f0c",
  null
  
)

export default component.exports